<ul class="sublevel-nav" routerLinkActive="active-submenu">
  <ng-container>
    <li
      *ngFor="let item of visibleItems; let i = index"
      class="sublevel-nav-item"
    >
      <a
        *ngIf="collapsed"
        class="sublevel-nav-link"
        [routerLink]="[item.route_link]"
        routerLinkActive="active-sublevel"
        (click)="handleClick(item)"
      >
        <span *ngIf="collapsed" class="sublevel-link-text">{{
          item.sub_menu_name
        }}</span>
      </a>
    </li>
  </ng-container>
</ul>
